// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__12jd6","modalFooterButton":"ModalNotes_modalFooterButton__3Rvdl"};